import { actions, initialState } from "./state";

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actions.CHANGE_KUNJUNGAN:
			return {
				...state,
				kunjungan: action.payload,
			};
		case actions.CHANGE_LOADING:
			return {
				...state,
				loading: action.payload,
			};

		default:
			return state;
	}
};
